import {
  PublicClientApplication,
  AuthenticationResult,
  EndSessionRequest,
} from '@azure/msal-browser';
import { msalConfig, loginRequest } from './AuthConfig';

class AzureAuthService {
  private msalInstance: PublicClientApplication;

  constructor() {
    this.msalInstance = new PublicClientApplication(msalConfig);
  }

  async initialize(): Promise<void> {
    await this.msalInstance.initialize();
  }

  async loginWithPopup(): Promise<AuthenticationResult | null> {
    try {
      const response = await this.msalInstance.loginPopup(loginRequest);
      return response;
    } catch (error) {
      console.error('Erro no login SSO:', error);
      throw error;
    }
  }

  async loginWithRedirect(): Promise<void> {
    try {
      await this.msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Erro no login SSO redirect:', error);
      throw error;
    }
  }

  async logout(): Promise<void> {
    const logoutRequest: EndSessionRequest = {
      account: this.getActiveAccount(),
      postLogoutRedirectUri: window.location.origin,
    };

    await this.msalInstance.logoutPopup(logoutRequest);
  }

  getActiveAccount() {
    const accounts = this.msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      return accounts[0];
    }
    return null;
  }

  isAuthenticated(): boolean {
    return this.getActiveAccount() !== null;
  }

  async getAccessToken(): Promise<string | null> {
    const account = this.getActiveAccount();
    if (!account) {
      return null;
    }

    try {
      const response = await this.msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account,
      });
      console.log('Token JWT recebido do SSO:', response.accessToken);
      return response.accessToken;
    } catch (error) {
      console.error('Erro ao obter token:', error);
      return null;
    }
  }

  getUserInfo() {
    const account = this.getActiveAccount();
    if (account) {
      return {
        id: account.localAccountId,
        username: account.username,
        name: account.name,
        email: account.username,
      };
    }
    return null;
  }

  async getCompleteAuthData(): Promise<{
    accessToken: string;
    account: any;
    user: {
      id: string;
      email: string;
      name: string;
    };
  } | null> {
    const account = this.getActiveAccount();
    if (!account) {
      return null;
    }

    try {
      const tokenResponse = await this.msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account,
      });

      return {
        accessToken: tokenResponse.accessToken,
        account: {
          homeAccountId: account.homeAccountId,
          environment: account.environment,
          tenantId: account.tenantId,
          username: account.username,
          localAccountId: account.localAccountId,
          name: account.name,
          authorityType: account.authorityType,
          tenantProfiles: account.tenantProfiles || {},
          idTokenClaims: tokenResponse.idTokenClaims || account.idTokenClaims,
          idToken: tokenResponse.idToken,
        },
        user: {
          id: account.localAccountId,
          email: account.username,
          name: account.name || '',
        },
      };
    } catch (error) {
      console.error('Erro ao obter dados completos da autenticação:', error);
      return null;
    }
  }
}

export default new AzureAuthService();
